import {
  useStyle 
} from "@/classify"
import defaultClasses from "./icon.module.css"

const Icon = (props) => {
  const {
    attrs,
    classes: propClasses,
    size,
    src: Component,
    ...restProps
  } = props
  const {
    width, ...restAttrs 
  } = attrs || {}
  const classes = useStyle(defaultClasses, propClasses)

  return (
    <span className={classes.root} {...restProps}>
      <Component
        className={classes.icon}
        size={size || width}
        {...restAttrs}
      />
    </span>
  )
}

export default Icon
